import { render, staticRenderFns } from "./RespondersMatchedToTag.vue?vue&type=template&id=2c756ae0&"
import script from "./RespondersMatchedToTag.vue?vue&type=script&lang=js&"
export * from "./RespondersMatchedToTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports